import { HeartHandshake, MessageCircle, PawPrint, MapPin, ClipboardCheck, Receipt } from "lucide-react";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";
import { useLang } from "../../i18n";

const ICONS = [HeartHandshake, MessageCircle, PawPrint, MapPin, ClipboardCheck, Receipt];

const Trust = () => {
    const { t } = useLang();
    return (
        <section data-testid="trust-section" className="bg-[#EFEADF]">
            <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
                <SectionHead
                    eyebrow={t.trust.eyebrow}
                    title={t.trust.title}
                    sub={t.trust.sub}
                    testid="trust-title"
                />
                <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {t.trust.items.map((item, i) => {
                        const Icon = ICONS[i];
                        return (
                            <Reveal key={item.title} delay={(i % 3) * 0.08}>
                                <div className="h-full rounded-[1.5rem] border border-[#E3DCCF] bg-cream p-7 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg">
                                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                                        <Icon size={20} />
                                    </span>
                                    <h3 className="font-serif mt-4 text-xl font-semibold text-ink">{item.title}</h3>
                                    <p className="mt-2 text-sm leading-relaxed text-[#525B53]">{item.desc}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Trust;
